import React, { useContext } from 'react';
import { EditLineItemModal, OrderQueryMutationKey, usePatchOrderLineItemMutation } from '@printdeal/checkout-frontend';
import { clearPendingPayment } from '../../../../../../helpers/payments/PendingPaymentHelper';
import { dispatchAccountEvent } from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';
import { SanitizedLineItem } from '../../../../../../types/order/Order';
import OrderDetailContext from '../../../contexts/OrderDetailContext';

interface Props {
  orderId: string;
  lineItem: SanitizedLineItem;
  setIsModalOpen: (state: boolean) => void;
}

const EditOrderLineItemModal = ({ orderId, lineItem, setIsModalOpen } : Props) => {
  const { reFetchOrder, order } = useContext(OrderDetailContext);
  const patchOrderLineItemMutation = usePatchOrderLineItemMutation({
    context: OrderQueryMutationKey.patchLineItem,
    onSuccess: () => {
      if (reFetchOrder) {
        reFetchOrder({ reFetchPaymentLink: true });
      }
      clearPendingPayment(orderId);
      dispatchAccountEvent('order_detail_interaction', 'approve_edit_lineItem');

      setIsModalOpen(false);
    },
  });

  return (
    <EditLineItemModal
      lineItem={lineItem}
      customLineItems={order!.customLineItems}
      isOpen
      onClose={() => {
        dispatchAccountEvent('order_detail_interaction', 'modal_is_closed');
        setIsModalOpen(false);
      }}
      onSubmitChanges={async ({
        changedAttributes, quantity, willRemoveArtwork: removeFile, newUserSelection, deliveryOptionId,
      }, callback) => {
        if (!changedAttributes) {
          setIsModalOpen(false);
        }

        patchOrderLineItemMutation.mutateAsync({
          orderId,
          lineItemId: lineItem.id,
          removeFile,
          payload: {
            editLineItem: [{
              lineItemId: lineItem.id,
              userSelection: newUserSelection,
              quantity,
              ...deliveryOptionId && { shipping: { deliveryOptionId } },
            }],
          },
        }).finally(callback);
      }}
      error={patchOrderLineItemMutation.error}
    />
  );
};

export default EditOrderLineItemModal;
